import { z } from 'zod';

export const productSchema = z.object({
  name: z.string().nonempty(),
  description: z.string().nonempty(),
  quantity: z.number().min(1),
  price: z.number().nonnegative(),
  discount: z.number(),
  discount_type: z.string().nullable(),
  tax: z.number(),
  amount: z.number().nonnegative(),
});

export const FormSchema = z
  .object({
    invoice_number: z
      .string({
        required_error: 'Invoice number is required.',
      })
      .nonempty(),
    currency: z.string().nonempty(),
    logo: z.string().min(1, 'Logo is required'),
    partner_id: z.string({
      required_error: 'Partner is required.',
    }),
    contact_id: z.number().optional().nullable(),
    dateRange: z.object(
      {
        from: z.date(),
        to: z.date(),
      },
      {
        required_error: 'Please select a date range',
      },
    ),
    invoice_products: z.array(productSchema),
    signature_name: z.string(),
    signature: z.string().optional(),
    description: z.string(),
    subtotal: z.number(),
    tax: z.number(),
    total: z.number(),
    amount_due: z.number(),
  })
  .refine((data) => data.dateRange.from < data.dateRange.to, {
    path: ['dateRange'],
    message: 'From date must be before to date',
  });
